import validate from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/node_modules/nuxt/dist/pages/runtime/validate.js";
import program_45filter_45global from "/home/runner/work/asuo-mktg-primary-microsite/asuo-mktg-primary-microsite/middleware/programFilter.global.ts";
export const globalMiddleware = [
  validate,
  program_45filter_45global
]
export const namedMiddleware = {}